import { locationIdFormat } from "@redotech/redo-ids-cockroach";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { ProcessingSession } from "./processing-session";

export const createProcessingSession = {
  name: "createProcessingSession" as const,
  input: z.object({
    returnId: zExt.objectId(),
    locationId: locationIdFormat.schema,
  }),
  output: z.object({ session: ProcessingSession }),
};
